import { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const EditableBlockList = ({ onDateChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedPeriod, setSelectedPeriod] = useState(null);

  const [appointmentTime, setAppointmentTime] = useState("");
  const [appointmentEndTime, setAppointmentEndTime] = useState("");

  const toggleDropdown = () => setIsOpen(!isOpen);
  const toggleCalendar = () => setShowCalendar(!showCalendar);

  const calculateDate = (days) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
  };

  const onDateSelect = (date) => {
    setSelectedDate(date);
    setShowCalendar(false);
    notifyParent(date, appointmentTime, appointmentEndTime);
  };

  const handlePredefinedDateClick = (days) => {
    const newDate = calculateDate(days);
    setSelectedDate(newDate);
    setSelectedPeriod(days);
    notifyParent(newDate, appointmentTime, appointmentEndTime);
  };

  const notifyParent = (date, time, endTime) => {
    onDateChange({
      date,
      appointmentTime: time,
      appointmentEndTime: endTime,
    });
  };

  const handleTimeChange = (e) => {
    setAppointmentTime(e.target.value);
    notifyParent(selectedDate, e.target.value, appointmentEndTime);
  };

  const handleEndTimeChange = (e) => {
    setAppointmentEndTime(e.target.value);
    notifyParent(selectedDate, appointmentTime, e.target.value);
  };

  const getButtonStyle = (days) =>
    days === selectedPeriod
      ? {
          borderRadius: "5px",
          border: "1px solid #FF9800",
          color: "#fff",
          cursor: "pointer",
        }
      : {
          background: "#FF980029",
          borderRadius: "5px",
          cursor: "pointer",
        };

  return (
    <div className="editable-block-list">
      <div className="position-relative">
        <p
          className="py-3 fw-bold ms-5"
          onClick={toggleDropdown}
          style={{ cursor: "pointer" }}
        >
          Follow-up
          <i className="bi bi-caret-down-fill" style={{ color: "#FF9800" }}></i>
        </p>
      </div>

      {isOpen && (
        <div className="row">
          <div className="col-1"></div>
          <div className="col-12 col-md-5 mx-auto mb-3 align-self-center">
            <p>
              <strong>Schedule follow-up appointment (control):</strong>
            </p>
          </div>
          <div className="col-12 col-md-2 mx-auto mb-3" onClick={() => handlePredefinedDateClick(5)}>
            <p className="p-2 text-center" style={getButtonStyle(5)}>
              <strong style={{ color: "#FF9800" }}>in 5 days</strong>
            </p>
          </div>
          <div className="col-12 col-md-2 mx-auto mb-3" onClick={() => handlePredefinedDateClick(10)}>
            <p className="p-2 text-center" style={getButtonStyle(10)}>
              <strong style={{ color: "#FF9800" }}>in 10 days</strong>
            </p>
          </div>
          <div className="col-12 col-md-2 mx-auto mb-3 align-self-center" onClick={toggleCalendar}>
            <p>
              <strong>or</strong>
              <i className="bi bi-calendar3 ms-2 fs-3" style={{ color: "#FF9800" }}></i>
            </p>
          </div>

          {/* Calendrier */}
          {showCalendar && (
            <div className="cale">
              <div className="w-50">
                <div className="calendar-container">
                  <Calendar onChange={onDateSelect} value={selectedDate} />
                </div>
                <div className="d-flex justify-content-center" style={{ marginTop: "-20px" }}>
                  <button
                    className="btn btn-war mt-3 text-white"
                    style={{ background: "#FF9800" }}
                    onClick={() => setShowCalendar(false)}
                  >
                    Apply Now
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Time selectors */}
          <div className="col-12 col-md-6 mx-auto mt-3"></div>
          <div className="col-12 col-md-3 mx-auto mt-2 mb-5">
            <label>Start Time:</label>
            <input
              type="time"
              className="form-control"
              value={appointmentTime}
              onChange={handleTimeChange}
            />
          </div>

          <div className="col-12 col-md-3 mx-auto mt-2 mb-5">
            <label>End Time:</label>
            <input
              type="time"
              className="form-control"
              value={appointmentEndTime}
              onChange={handleEndTimeChange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EditableBlockList;
